import { stepConfigItem } from './types';
import { DietIdEnum } from '@front-activerse/common-components';

const stepsSchemaPl: stepConfigItem[] = [
  {
    id: 'dietType',
    slug: 'diet-type',
    fork: {
      chooseChild: (state: { dietType: any }) =>
        state.dietType === DietIdEnum.DIET_ID_CLASSIC ||
        state.dietType === DietIdEnum.DIET_ID_CLASSIC_LVL2 ||
        state.dietType === DietIdEnum.DIET_ID_CLASSIC_LVL3
          ? 'withDietLevel'
          : 'normal',
      children: {
        withDietLevel: [
          {
            id: 'dietLevel',
            slug: 'diet-level',
          },
          { id: 'summary', slug: 'summary' },
        ],
        normal: [{ id: 'summary', slug: 'summary' }],
      },
    },
  },
];

export default stepsSchemaPl;
